const api = {
  getMCardConfiguration(customerNumber, surveyTypeCode) {
    return `/customers/${customerNumber}/survey-type/${surveyTypeCode}/configuration/mcard`;
  }, 
  getMCardData(customerNumber, surveyTypeCode) {
    return `/customers/${customerNumber}/survey-type/${surveyTypeCode}/configuration`;
  }, 
  updateMCardData(customerNumber, surveyTypeCode) {
    return `/customers/${customerNumber}/survey-type/${surveyTypeCode}/configuration`;
  },
  getSurveyTypeForms(customerNumber, surveyTypeCode) {
    return `/customers/${customerNumber}/survey-type/${surveyTypeCode}/forms`;
  },
  addUpdateRemoveForm(customerNumber, surveyTypeCode, formCode) {
    return `/customers/${customerNumber}/survey-type/${surveyTypeCode}/form/${formCode}`;
  },
  getActiveForms(customerNumber) {
    return `/customers/${customerNumber}/forms`;
  },
  notifications(customerNumber, surveyTypeCode) {
    return `/customers/${customerNumber}/survey-type/${surveyTypeCode}/notifications`;
  },
  notificationTypes() {
    return `/customers/notifications/types`;
  },
  notificationMethods() {
    return `/customers/notifications/methods`;
  },
  notificationLetters() {
    return `/customers/notifications/letters`;
  },
  addUpdateRemoveNotifications(customerNumber, surveyTypeCode, notificationTypeCode) {
    return `/customers/${customerNumber}/survey-type/${surveyTypeCode}/notifications/${notificationTypeCode}`;
  },
  copySurveyType(customerNumberTo, surveyTypeCode, customerNumberFrom) {
    return `/customers/${customerNumberTo}/survey-type/${surveyTypeCode}/copy-from/${customerNumberFrom}`;
  },
  customer360ValueSettings(customerNumber) {
    return `/customers/${customerNumber}/calc-tools/settings-360`;
  }
};

export default api;
